import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const devicesRoutes: Routes = [
	{
		path: 'devices',
		canMatch: [roleGuard],
		data: { allowedRoles: [RoleCode.SUPER_ADMIN] },
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./pages/devices-list-page/devices-list-page.component').then(c => c.DevicesListPageComponent)
			}
		]
	}
];
